// Feature flags for GameCityUX.
//
// CONNECT_ENABLED — gates the Game.City Connect (mirror) feature:
// NavMenu links, /connect and /mirror routes, ConnectCard in Lobby,
// and PlayerConnectControl in Play. Flip to true to re-enable.
export const CONNECT_ENABLED = false;
